export default "__VITE_ASSET__DuEZn9b6__"